<template>
  <popup class="loading-popup">
    <template v-slot:content>
      <div class="loading-popup-content">
        <lottie-player :src="JSON.stringify(require('@/assets/animations/loader.json'))" :autoplay="true" :loop="true"/>
        <div class="description">
          <div class="title">{{ title }}</div>
          <div class="subtitle">{{ subtitle }}</div>
        </div>
      </div>
    </template>
  </popup>
</template>

<script>
import BaseUI from 'base-ui';

export default {
  name: 'LoadingPopup',
  components: {
    Popup: BaseUI.Popup,
  },
  props: {
    title: {
      type: String,
    },
    subtitle: {
      type: String,
    },
  },
  computed: {
  },
  methods: {
  },
};
</script>

<style scoped lang="scss">
  @import '../../../node_modules/base-ui/src/scss/riseup-colors';

  .loading-popup {
    width: 100%;

    .loading-popup-content {
      lottie-player {
        margin: 36px 0 60px 0;
        height: 100px;
        text-align: center;
      }

      .description {
        color: $riseup_black;
        width: 100%;
        text-align: center;
        margin-bottom: 36px;

        .title {
          line-height: 1.33;
          font-size: 18px;
          font-weight: bold;
          margin-bottom: 10px;
          font-family: SimplerPro;
        }
        .subtitle {
          line-height: 1.33;
          font-size: 18px;
          font-family: SimplerPro;
        }
      }
    }
  }
</style>
